import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';
import { appRoutes } from '../routes';

export const useInternalRoutes = () => {
  const [searchParams] = useSearchParams();

  const routes = useMemo(
    () => ({
      templates: {
        build: (slug: string) =>
          appRoutes.templates.build({ slug, searchParams }),
      },
      search: {
        build: (criteria: string) =>
          appRoutes.search.build({ criteria, searchParams }),
      },
    }),
    [searchParams],
  );

  return routes;
};
